import { Component, ElementRef, ViewChild, ChangeDetectionStrategy , inject} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTab } from '@angular/material/tabs';
import { TipoPrecioCombustible } from '@/app/models/PrecioCombustible';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';




@Component({
    selector: 'app-precios-combustibles',
    templateUrl: './precios-combustibles.component.html',
    styleUrls: ['./precios-combustibles.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PreciosCombustiblesComponent   {
  private spinner = inject(NgxSpinnerService);
  
  //validaciones
  hasFinished: boolean = false;

  //forms
  precios: TipoPrecioCombustible[] =
  [
    { precio: '',  tipo: 'Magna' }, //0
    { precio: '',  tipo: 'Premium' }, //1
    { precio: '',  tipo: 'Diesel' }, //2
  ]

  constructor(
    public dialogRef: MatDialogRef<PreciosCombustiblesComponent>,
  ){
  }

  responseContent(event: boolean){
    if(!event){
      this.dialogRef.close({updateList: false});
    }else{
      this.dialogRef.close({updateList: true});
    }
  }
}
